import { type DownloadedFile, fetchChatAttachment, fetchChatAttachmentPreview } from "@/api";

/** A stored file the document previews can show: its original bytes and a PDF rendering of it. */
export interface PreviewFile {
  /** Query-cache identity; the file's content must not change under one key. */
  key: readonly (string | number)[];
  original: () => Promise<DownloadedFile>;
  pdf: () => Promise<DownloadedFile>;
}

export function chatAttachmentFile(attachmentUuid: string): PreviewFile {
  return {
    key: ["chat", "attachment", attachmentUuid],
    original: () => fetchChatAttachment(attachmentUuid),
    pdf: () => fetchChatAttachmentPreview(attachmentUuid),
  };
}
